import { ProductBuilderState } from '../state'

export const productBuilderNotificationVisibilitySet = (state: ProductBuilderState, params: { notificationIndex: number, visible: boolean }): ProductBuilderState => {
    const notifications = [...state.notifications]
    const notification = notifications[params.notificationIndex]
    notification.closed = !params.visible
    return {
        ...state,
        notifications: notifications
    }
}